export enum TemperatureUnit {
  METRIC = "metric",
  IMPERIAL = "imperial",
}
